// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pP-9","importantInfo":"styles_importantInfo__1tHoT"};